import { useState, useEffect } from 'react';
import '../styles/GeneralStyles.css';
import '../styles/ResultSteps.css';
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp';
import iconArrowLeft from '../assets/arrow-left.svg'
import iconCalendar from '../assets/calendar.svg'

const ResultStep = ({ formData, prevStep, nextStep }) => {
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const calculateTotal = () => {
      let sum = 0;
      
      // Recorre los objetos en formData
      Object.values(formData).forEach(item => {
        // Verifica si el item es un objeto y tiene la propiedad value
        if (item && typeof item === 'object' && 'value' in item) {
          sum += parseInt(item.value) || 0;
        }
      });

      // Agrega monto extra según el selectedId de carats
      if (formData.carats?.selectedId) {
        switch(formData.carats.selectedId) {
          case 1:
            sum += 18000;
            break;
          case 2:
            sum += 27000;
            break;
          case 3:
            sum += 31500;
            break;
          case 4:
            sum += 33750;
            break;
          default:
            break;
        }
      }
      
      setTotal(sum);
    };
  
    calculateTotal();
  }, [formData]);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const summaryData = {
        fldCgRVqACdWQDwtU: formData.firstName, // Nombre
        fldlyelyPjVLNIdA1: formData.lastName, // Apellido
        fld9uSCaKUJ308x6m: formData.phone, // Teléfono
        fldM1K4cPzwMed6C0: formData.email, // Email
        fld7gnxozCjewn9tm: formData.cutStyle.text, // Corte
        fldtxCMHEaeStV0hw: formData.ringColor.text, // Color
        fldZKHEyLRH6FxuIo: formData.clarity.text, // Pureza
        fld7eDJrtMULYFlkF: formData.carats.text, // Quilates
        fldJ35X4MX6nQaC6E: formData.montura.text, // Montura
        fldJLejh2I7NLZhcS: formData.material.text, // Material
        fldCyGaZfZ9daL0dw: total.toLocaleString('en-US') // Total
      };



    

      console.log(summaryData);
      const response = await fetch('https://api.airtable.com/v0/appRxrhvD7oYbU8zO/tblTbbK5k46J5hXP2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer patyg5JqdQkMbZaVS.83385fd76a9909232ca2a84e2b823a80073a460ad524fee6adb4f01a4379e619'
        },
        body: JSON.stringify({
          "records": [
            {
              "fields": summaryData
            }
          ],
          "typecast": true
        })
      });

      if (!response.ok) {
        throw new Error('Error al enviar la cotización');
      }

      const data = await response.json();
      
      if (data && data.records && data.records.length > 0) {
        // Solo avanzar al siguiente paso si la respuesta es exitosa y contiene registros
        nextStep(); // Redirige al siguiente paso (CalendlyStep)
      } else {
        throw new Error('La respuesta no contiene los datos esperados');
      }
      
    } catch (error) {
      console.error('Error:', error);
      alert('Hubo un error al enviar la cotización');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className='wrapp-summary'>
        
        
        <div className="summary-tables">
            <div className='text-n-options'>
                <h2 className='heading-style-h3 text-align-center'>Revisa y confirma tu diseño</h2>
                <p className='text-size-medium text-color-grey'>¡Estás a un paso de crear el anillo perfecto! Verifica que toda la información sea correcta, desde el corte hasta el material.
                <br />
                <br />
                ¿Buscas otro modelo? Envíanos un mensaje a <a href='info@tressor.com'>info@tressor.com</a> y te enviaremos una cotización personalizada.</p>
            </div>
        

          <div className="choices-summary">
            <table className="summary-table">
              <tbody>
                <tr className='header-table'>
                  <th>Descripción</th>
                  <th>Opción seleccionada</th>
                  <th>Valor</th>
                </tr>
                <tr>
                  <td>Quilates</td>
                  <td>{formData.carats.text || '-'}</td>
                  <td>${formData.carats.value || 0}</td>
                </tr>
                <tr>
                <td>Color</td>
                  <td>{formData.ringColor.text || '-'}</td>
                  <td>${formData.ringColor.value || 0}</td>
                  
                </tr>
                <tr>
                  <td>Corte</td>
                  <td>{formData.cutStyle.text || '-'}</td>
                  <td>${formData.cutStyle.value || 0}</td>
                  
                </tr>
                <tr>
                <td>Claridad</td>
                  <td>{formData.clarity.text || '-'}</td>
                  <td>${formData.clarity.value || 0}</td>

                  
                </tr>
                <tr>
                  <td>Montura</td>
                  <td>{formData.montura.text || '-'}</td>
                  <td>${formData.montura.value || 0}</td>
                </tr>
                <tr>
                  <td>Material</td>
                  <td>{formData.material.text || '-'}</td>
                  <td>${formData.material.value || 0}</td>
                </tr>
                
              </tbody>
            </table>
          </div>

          <div className="user-data-summary">
          
            <table className="summary-table">
              <tbody>
                <tr className='header-table'>
                  <th>Descripción</th>
                  <th>Información</th>
                </tr>
                <tr>
                  <td>Nombre</td>
                  <td>{formData.firstName || '-'}</td>
                </tr>
                <tr>
                  <td>Apellido</td>
                  <td>{formData.lastName || '-'}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{formData.email || '-'}</td>
                </tr>
                <tr>
                  <td>Teléfono</td>
                  <td>{formData.phone || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='total-price'>
        
        <h2 className='heading-style-h3'>Total $ {total.toLocaleString('en-US')} MXN</h2>
        <p className='text-size-medium text-color-grey' style={{maxWidth: '500px', margin: '0 auto'}}>Este precio es estimado y puede variar según el diseño y la complejidad del anillo.</p>
        </div>
        <div className="wrapp-btns">
          <button className="button-prev" onClick={prevStep}>
            <img src={iconArrowLeft} alt="arrow left" />
            Volver
          </button>
          <button 
            className="button"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Enviando...' : 'Agendar cita'}
            <img src={iconCalendar} alt="calendar" />
          </button>
        </div>
        </div>
        
        
        </div>
        <div className='wrapp-preview'>
            <div className="decorative-img">
                <img src={imgAnilloBodasPrev} className='imgPreviewNoText' alt="Preview anillo" />
            </div>
        

        </div>
       
      </div>
    </div>
  );
};

export default ResultStep;
